import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Commission } from 'src/model/commission.model';
import { AddCommissionPaymentComponent } from '../add-commission-payment/add-commission-payment.component';
import { EditCommissionComponent } from '../edit-commission/edit-commission.component';

interface UnpaidStaffCommissionInterface {
  StaffUsername: string;
  UnpaidComissionList: Commission[];
}

@Component({
    selector: 'app-comission-list',
    templateUrl: './comission-list.component.html',
    styleUrls: ['./comission-list.component.scss'],
    standalone: false
})
export class ComissionListComponent implements OnInit {
  private router = inject(Router);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  private cdr = inject(ChangeDetectorRef);
  private sharedService = inject(SharedService);

  commissionList: Commission[] = [];

  unpaidStaffCommissionList: UnpaidStaffCommissionInterface[] = [];
  // unpaidCommissionList: Commission[] = new Array;

  displayedColumns: string[];
  dataSource = new MatTableDataSource;

  innerWidth: any;
  showRemark: string;
  isCollapsed = true;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  loggedInRole: number;
  loggedInUsername: string;

  ngOnInit(): void {
    this.loggedInRole = Number(sessionStorage.getItem('roleId'));
    this.loggedInUsername = sessionStorage.getItem('username');

    this.loadUnpaidCommission();
  }

  isAssignedByLoggedInUser(commission: Commission) {
    const loggedInUsername = sessionStorage.getItem("username");

    // console.log(commission.Assignor)
    if (loggedInUsername == commission.Assignor)
      return true;

    else
      return false;
  }

  confirmBeforeAssignAll() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You are going to clear all the commissions, are you sure about that?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.assignAllCommissions();
    });
  }

  assignAllCommissions() {
    const editIds: number[] = [];
    for (let i = 0; i < this.commissionList.length; i++) {
      editIds.push(Number(this.commissionList[i].LoanId))
    }

    this.batchAssignAmountAndAssignee(this.loggedInUsername, editIds, 0)
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  assignCommission(commission: Commission) {
    // alert(commission.Rate + "|" + commission.Assignee)
    if (commission.Assignee == undefined || commission.Amount == undefined)
      this.sharedService.openAlert("Please key in commission amount and assignee!", ALERT_TYPE.DANGER);
    else
      this.assignRateAndAssignee(commission, true);
  }

  assignRateAndAssignee(commission: Commission, showAlert: boolean) {
    const data = {
      "amount": Number(commission.Amount),
      "loanId": commission.LoanId,
      "assignee": commission.Assignee,
      "dateCreated": new Date()
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAssignCommission(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        // var jsonArray = JSON.parse((xhr.responseText));

        if (showAlert == true)
          this.sharedService.openAlert("Successfully assign commission!", ALERT_TYPE.SUCCESS);
        commission.Assigned = true;
      }
    };
  }

  fillInAllPayment(unpaidCommissionStaff: string) {
    const index = this.unpaidStaffCommissionList.findIndex(commission => commission.StaffUsername == unpaidCommissionStaff);

    for (let i = 0; i < this.unpaidStaffCommissionList[index].UnpaidComissionList.length; i++) {
      this.unpaidStaffCommissionList[index].UnpaidComissionList[i].PaymentAmount = this.unpaidStaffCommissionList[index].UnpaidComissionList[i].Amount - this.unpaidStaffCommissionList[index].UnpaidComissionList[i].Paid;
    }

    this.submitPayment(this.unpaidStaffCommissionList[index]);
  }

  batchAssignAmountAndAssignee(assignee: string, loanIds: number[], amount: number) {
    const data = {
      "amount": amount,
      "loanIds": loanIds,
      "assignee": assignee,
      "dateCreated": new Date()
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAssignCommission(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        // var jsonArray = JSON.parse((xhr.responseText));

        this.sharedService.openAlert("Successfully batch assign commission!", ALERT_TYPE.SUCCESS);
        window.location.reload();
      }
    };
  }

  goToCustomer(selectedID: number) {
    // console.log("selcted:" + selectedID);
    // this.router.navigateByUrl('/manageCustomer', { state: { id: selectedID } });
    this.router.navigate(['/manageCustomer', selectedID]);
  }

  getAllCommission() {
    //default paginationDate: within 1 year
    const lastDate = new Date();
    lastDate.setFullYear(new Date().getFullYear() - 1);

    const xhttp = this.restapi.getRequest(this.constructApi.getAllPendingCommissions(undefined, true, lastDate.toISOString()))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          const commission = new Commission(json.id, json.loanId, json.rate, json.assignee, json.assignor, json.transactionId, json.dateCreated,
            json.customerId, json.customerName, json.principal, false, undefined, undefined, json.customerCode, json.companyId, json.companyCode, json.scheme)

          this.commissionList.push(commission);
        });
      }
    };
  }

  loadUnpaidCommission() {
    if (this.unpaidStaffCommissionList.length > 0)
      this.unpaidStaffCommissionList.splice(0, this.unpaidStaffCommissionList.length);

    const companyId = Number(sessionStorage.getItem('companyId'));
    this.getCompanyUnpaidCommission(companyId);
  }

  calculateUnpaidAmount(commissionList: Commission[]) {
    let total = 0;

    for (let i = 0; i < commissionList.length; i++) {
      total += commissionList[i].Amount;
    }
    return Math.round(total);
  }

  calculateBalanceAmount(commissionList: Commission[]) {
    let total = 0;

    for (let i = 0; i < commissionList.length; i++) {
      const paid = (commissionList[i].Paid == undefined) ? 0 : commissionList[i].Paid;
      total += commissionList[i].Amount - paid;
    }
    return Math.round(total);
  }

  calculatePaymentAmount(commissionList: Commission[]) {
    let total = 0;

    for (let i = 0; i < commissionList.length; i++) {
      total += commissionList[i].PaymentAmount;
    }
    return Math.round(total);
  }

  roundTo2Dec(num: number) {
    return Math.round(num * 100) / 100
  }

  getCompanyUnpaidCommission(companyId: number) {
    const xhttp = this.restapi.getRequest(this.constructApi.getCompanyUnpaidCommission(companyId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          // alert(JSON.stringify(json));
          //get assignee username
          const username = json.assignee;

          //get index in the unpaid list if exist
          const index = this.unpaidStaffCommissionList.findIndex(unpaidStaff => unpaidStaff.StaffUsername === username);
          const commissionList: Commission[] = [];
          // alert(index);
          //get comission
          const paid = (json.paid == undefined) ? 0 : json.paid;
          const commission = new Commission(json.id, json.loanId, json.amount, json.assignee, json.assignor, json.transactionId, json.dateCreated, json.customerId, json.customerName, json.principal,
            undefined, 0, paid, json.customerCode);

          //if assignee not existed before
          if (index == -1) {
            commissionList.push(commission);
            //add into the list
            const staffUnpaidCommission = { StaffUsername: username, UnpaidComissionList: commissionList }
            this.unpaidStaffCommissionList.push(staffUnpaidCommission);
          }
          else {
            //if assignee existed before, append the new commission into the commission list
            this.unpaidStaffCommissionList[index].UnpaidComissionList.push(commission);
          }
        });
      }
    };
  }

  openEditCommissionModal(commission: Commission) {
    const modalRef = this.sharedService.openModal(EditCommissionComponent);
    modalRef.componentInstance.amount = commission.Amount;
    modalRef.componentInstance.assignee = commission.Assignee;
    modalRef.componentInstance.loanId = commission.LoanId;
    modalRef.componentInstance.commissionId = commission.ID;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }

  checkError(unpaidCommission: UnpaidStaffCommissionInterface) {
    for (let i = 0; i < unpaidCommission.UnpaidComissionList.length; i++) {
      const paid = (unpaidCommission.UnpaidComissionList[i].Paid == undefined) ? 0 : unpaidCommission.UnpaidComissionList[i].Paid;
      if (unpaidCommission.UnpaidComissionList[i].Amount - paid < unpaidCommission.UnpaidComissionList[i].PaymentAmount)
        return true
    }
    return false;
  }

  submitPayment(unpaidCommission: UnpaidStaffCommissionInterface) {
    if (this.checkError(unpaidCommission) == false) {
      this.openAddCommissionPaymentModal(unpaidCommission);
    }
    else
      this.sharedService.openAlert("Please make sure payment amount is correct! \nYou can only pay maximum of the balance commission amount!", ALERT_TYPE.DANGER)
  }

  openAddCommissionPaymentModal(unpaidCommission: UnpaidStaffCommissionInterface) {
    const modalRef = this.sharedService.openModal(AddCommissionPaymentComponent);
    modalRef.componentInstance.unpaidCommission = unpaidCommission;

    // var total = 0;
    // for (let i = 0; i < unpaidCommission.UnpaidComissionList.length; i++)
    //   total += unpaidCommission.UnpaidComissionList[i].Amount;

    // modalRef.componentInstance.selectedCommissionAmount = Math.round(total);

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const commission = entry;

      this.unpaidStaffCommissionList.splice(0, this.unpaidStaffCommissionList.length);
      const companyId = Number(sessionStorage.getItem('companyId'));
      this.getCompanyUnpaidCommission(companyId);
    });

    modalRef.result.then(() => {
      this.cdr.detectChanges();
    })
  }

  confirmBeforeDeletingCommission(commission: Commission, staffIndex: number, commIndex: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete the commission of " + commission.Assignee + "- RM " + commission.Amount + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteCommission(commission.LoanId, commission.ID, staffIndex, commIndex);
    });
  }

  deleteCommission(loanId: number, commissionId: number, staffIndex: number, commIndex: number) {
    const xhttp = this.restapi.deleteRequest(this.constructApi.getDeleteLoanCommission(loanId, commissionId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        //remove the commission from list
        this.unpaidStaffCommissionList[staffIndex].UnpaidComissionList.splice(commIndex, 1);

        //remove the staff  list if no longer have any commission inside staff list
        if (this.unpaidStaffCommissionList[staffIndex].UnpaidComissionList.length == 0)
          this.unpaidStaffCommissionList.splice(staffIndex, 1);

        this.cdr.detectChanges();
      }
    };
  }
}
